var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.1404C8.39553 11.6728 8.90014 12.1134 9.47963 12.4322C10.0591 12.7511 10.6999 12.9407 11.3586 12.9882C12.0172 13.0357 12.6783 12.94 13.297 12.7076C13.9157 12.4751 14.4775 12.1115 14.9443 11.6412L17.7073 8.85882C18.5462 7.98423 19.0103 6.81284 18.9998 5.59697C18.9893 4.38109 18.505 3.21801 17.6512 2.35822C16.7974 1.49844 15.6424 1.01074 14.435 1.00018C13.2276 0.98961 12.0644 1.45702 11.1959 2.30173L9.61175 3.88768",
    stroke: "#888281",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.85964C11.6045 8.32717 11.0999 7.88658 10.5204 7.56776C9.94088 7.24894 9.30009 7.05935 8.64144 7.01185C7.98279 6.96435 7.32171 7.06004 6.70302 7.29245C6.08433 7.52486 5.52251 7.88853 5.05567 8.35882L2.29268 11.1412C1.45384 12.0158 0.989682 13.1872 1.00017 14.403C1.01067 15.6189 1.49497 16.782 2.34877 17.6418C3.20257 18.5016 4.35756 18.9893 5.56498 18.9998C6.77239 19.0104 7.93562 18.543 8.80413 17.6983L10.379 16.1123",
    stroke: "#888281",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.97c91974a398af40a83110bf559b24d8.svg";
export { ForwardRef as ReactComponent };